import { render } from "./InstructorsPage.vue?vue&type=template&id=3a0c25a3&scoped=true"
import script from "./InstructorsPage.vue?vue&type=script&lang=js"
export * from "./InstructorsPage.vue?vue&type=script&lang=js"

import "./InstructorsPage.vue?vue&type=style&index=0&id=3a0c25a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0c25a3"]])

export default __exports__